import { CSSProperties } from 'react';
import { StyleSheet } from 'react-native';
import { IMAGE_PREVIEW_ZINDEX } from '@shared/styles';
import { PREVIEW_MODAL_HEADER_HEIGHT } from '../constants';

export const styles: Record<string, CSSProperties> = {
  content: {
    backgroundColor: 'transparent',
    border: 'none',
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'visible',
    padding: 0,
    width: '100vw',
    height: '100%',
  },
  overlay: {
    display: 'flex',
    backgroundColor: '#000',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    zIndex: IMAGE_PREVIEW_ZINDEX,
  },
  title: {
    position: 'absolute',
    top: 0,
    margin: 0,
    height: PREVIEW_MODAL_HEADER_HEIGHT,
    // room for L and R button
    left: 80,
    right: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  titleInside: {
    textAlign: 'left',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export const Styles = StyleSheet.create({
  carouselContainer: {
    position: 'absolute',
    top: PREVIEW_MODAL_HEADER_HEIGHT, // room for buttons
    bottom: 0,
    left: 0,
    right: 0,
  },
  download: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: 56,
  },
  close: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 56,
  },
});
